import React, { useEffect, useState } from 'react';

import { reqApkList } from './../service'


import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import ic_files_empathy from '../images/ic_files_empathy.svg'

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}
const headCells = [
    { id: 'Version', numeric: false, disablePadding: true, label: 'version' },
    { id: 'description', numeric: true, disablePadding: false, label: 'Description' },
    // { id: 'action', numeric: true, disablePadding: false, label: '' }
];
function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead className="text-muted">
            <TableRow>

                {headCells.map((headCell) => (
                    <TableCell className="text-muted text-uppercase"
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}

                        </TableSortLabel>
                    </TableCell>
                ))}
                <TableCell></TableCell>
            </TableRow>
        </TableHead>
    );
}
function ListDownload() {

    const [apkList, setApkList] = useState([])
    // const [isLoading, setIsLoading] = useState(false);
    // const [isError, setIsError] = useState(false);

    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');

    const [page] = React.useState(0);
    const [rowsPerPage] = React.useState(25);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };
    const requestsApk = async () => {
        // setIsError(true);
        reqApkList().then(res => {
            // console.log(res)
            // setIsLoading(true);
            // setIsLoading(false);
            // setIsError(false);
            if (res.code === 200) {
                setApkList(res.result)
            }

        }).catch(err => {
            // setIsError(true);
        })
    }
    useEffect(() => {
        requestsApk()
    }, [])


    const emptyRows = rowsPerPage - Math.min(rowsPerPage, apkList.length - page * rowsPerPage);

    return (
        <>
            {/* <Header logo={ic_role_manage} navbarRight={navbarRight} /> */}
            <div className="px-3 pt-3 pb-2 mb-3">

                <div className="d-flex justify-content-between" >
                    <h5>APK List</h5>

                    <div className="d-flex justify-content-end">
                        <div className="d-flex bd-highlight mt-3">
                            <div className="flex-grow-1 bd-highlight">
                                {/* <div className="input-group mb-2">
                    <div className="input-group-prepend">
                      <div className="input-group-text bg-white pr-0"><SearchIcon></SearchIcon></div>
                    </div>
                    <input type="text" className="form-control border-left-0" id="inlineFormInputGroup" placeholder="Search Members" />
                  </div> */}
                            </div>
                            {/* <div className="bd-highlight"></div> */}
                            <div className="bd-highlight ml-4">
                                <form className="form-inline">
                                    {/* <Button variant="light" className="mb-2 border" onClick={goCreateRole}><AddIcon></AddIcon> Create Group</Button> */}
                                    <div className="form-group mx-sm-3 mb-2">
                                        {/* <input type="text" readonly className="form-control-plaintext" id="staticEmail2" value=": ThaiBev" /> */}
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>

                </div>
                <Paper className="mt-2 shadow-none">
                    {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
                    <TableContainer>
                        <Table

                            aria-labelledby="tableTitle"
                            size={'medium'}
                            aria-label="enhanced table"
                        >
                            <EnhancedTableHead
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}

                            />
                            <TableBody>

                                {apkList.length === 0 ? (
                                    <>
                                        <TableRow style={{ height: (15) * emptyRows }}>
                                            <TableCell colSpan={6} className="text-center">
                                                <img
                                                    width={40}
                                                    height={40}
                                                    className="m-3"
                                                    src={ic_files_empathy}
                                                    alt="Generic placeholder"
                                                />
                                                <p>ยังไม่มีข้อมูล</p>
                                            </TableCell>
                                        </TableRow>
                                    </>
                                ) : (
                                    <>

                                        {stableSort(apkList, getComparator(order, orderBy))
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((list, index) => {

                                                return (
                                                    <TableRow
                                                        hover
                                                        // onClick={(event) => handleClick(event, list.id)}
                                                        role="checkbox"
                                                        tabIndex={-1}
                                                        key={list.id}
                                                    >

                                                        <TableCell component="th" id={list.id} scope="row">
                                                            {list.version}
                                                        </TableCell>

                                                        <TableCell align="right">
                                                            {list.description}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <a target='_blank' href={list.file_url} rel="noreferrer" className='btn btn-light'>
                                                                <span className='mr-2'>Download</span>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
                                                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                                                </svg>
                                                            </a>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                    </>
                                )
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {/* <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            /> */}
                </Paper>
            </div>
        </>

    )
    // return (
    //     <>
    //         <Header logo={ic_role_manage} />
    //         <div className='container-fluid'>
    //             <div className="pt-3 pb-2 mb-3">
    //                 <div className="d-flex justify-content-between" >
    //                     <h5 class="mb-2">APK List</h5>

    //                     <div className="d-flex justify-content-end">
    //                         <div className="d-flex bd-highlight mt-3">
    //                             <div className="flex-grow-1 bd-highlight">
    //                                 {/* <div className="input-group mb-2">
    //             <div className="input-group-prepend">
    //               <div className="input-group-text bg-white pr-0"><SearchIcon></SearchIcon></div>
    //             </div>
    //             <input type="text" className="form-control border-left-0" id="inlineFormInputGroup" placeholder="Search Members" />
    //           </div> */}
    //                             </div>
    //                             {/* <div className="bd-highlight"></div> */}
    //                             <div className="bd-highlight ml-4">
    //                                 <form className="form-inline">
    //                                     {/* <Button variant="light" className="mb-2 border" onClick={goCreateRole}><AddIcon></AddIcon> Create Group</Button> */}
    //                                     <div className="form-group mx-sm-3 mb-2">
    //                                         {/* <input type="text" readonly className="form-control-plaintext" id="staticEmail2" value=": ThaiBev" /> */}
    //                                     </div>
    //                                 </form>

    //                             </div>
    //                         </div>
    //                     </div>

    //                 </div>
    //                 <ListGroup >
    //                     {
    //                         apkList.map((app, i) => {
    //                             return (
    //                                 <ListGroup.Item action href="#link1" key={i}>
    //                                     {app.version}
    //                                     <p className='mb-0'>{app.description}</p>
    //                                 </ListGroup.Item>
    //                             )
    //                         })
    //                     }

    //                 </ListGroup>
    //             </div>
    //         </div>
    //     </>
    // )
}
export default ListDownload